<div class="announcement">
  <app-container>
    <app-bread-crumbs />

    <h4 class="title">{{ this.page?.translation?.data?.title }}</h4>
  </app-container>
  <app-news-list></app-news-list>
</div>
